/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registrationOptions: { scope: './' },
    ready () {
      console.log('Ready')
      // console.log('push handler')
      // self.addEventListener('push', function (event) {
      //   console.log('Receiving push')
      //   console.log(event.data)
      //   let _data = event.data ? JSON.parse(event.data.text()) : {}
      //   // notificationUrl = _data.url;
      //   self.registration.showNotification(_data.titulo, {
      //     body: _data.contenido,
      //     icon: '/img/icon.png'
      //   })
      // })
      // self.addEventListener('notificationclick', function (event) {
      //   event.notification.close()
      //   // event.waitUntil(
      //   //   clients.matchAll({
      //   //     type: 'window'
      //   //   })
      //   //   .then(function (clientList) {
      //   //     if (clients.openWindow) {
      //   //       return clients.openWindow(notificationUrl);
      //   //     }
      //   //   })
      //   // )
      // })
    },
    registered () {
      console.log('Registered')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
